import React, { useState } from "react";
import { Box, Paper, Table, TableBody, TableContainer } from "@mui/material";
import EnhancedTableHead from "./TableHead";
import TableLists from "./TableList";

export {}; // Add this line to make it a module

const DashTable = ({ searchValue }: { searchValue: string }) => {
    const [order, setOrder] = useState<"asc" | "desc">("asc");
    const [orderBy, setOrderBy] = useState("dateTime");

    const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    return (
        <div className="Enhance-table">
            <Box sx={{ width: "100%" }}>
                <Paper sx={{ width: "100%", mb: 2 }}>
                    <TableContainer className="custom-tablebody">
                        <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                <TableLists order={order} orderBy={orderBy} />
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </div>
    );
};

export default DashTable;
